module.exports = __webpack_public_path__ + "img/peridical.19288d9b.png";